module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wasou-accessories-e49948bb94594b9fe80da1609be320d1.png";